import { GLOBAL } from 'saddlebag-browser';

import type { PRERENDER_DEPS } from '@web-platform/shared-universal-constants/src/homepage/prerenderDependencies';
import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

const $window = GLOBAL.getWindow();

export const setPrerenderReady = (component: Values<typeof PRERENDER_DEPS>) => {
  if ($window.banana && $window.banana.prerenderDependencies) {
    $window.banana.prerenderDependencies[component] = true;
    if (Object.values($window.banana.prerenderDependencies).every((isReady) => isReady)) {
      $window.prerenderReady = true;
    }
  }
};
